import { BufferGeometry as i } from "three";
import { mergeBufferGeometries as f } from "three-stdlib";
function a(r, t = []) {
  for (const e of r.children)
    a(e, t);
  const n = r.children.filter((e) => e.isMesh);
  return t.push(...n.map((e) => {
    const o = e.geometry.clone();
    return o.name = e.name, e.updateMatrix(), o.applyMatrix4(e.matrix), o.applyMatrix4(r.matrixWorld), o;
  })), t;
}
function c(r) {
  r.updateWorldMatrix(!1, !0);
  const t = a(r);
  let n;
  t.length ? n = f(t) : n = new i(), n.name = r.name;
  for (const e of t)
    e.dispose();
  return n;
}
export {
  c as mergeMeshes
};
//# sourceMappingURL=index17.js.map
